import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const Detail = ({
    show,
    handleClose,
    data
}) => {
    const vcimage = data.vcimage === '' || data.vcimage === null ? '' : `data:image/jpeg/jpg/png;base64,${data.vcimage}`
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">Detail Data</Modal.Title>
            <FalconCloseButton onClick={handleClose} variant="white" />
            </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <tbody>
                            <tr>
                                <td>Nomor Seri Becak</td>
                                <td>{data.vcnip}</td>
                            </tr>
                            <tr>
                                <td>Nama</td>
                                <td>{data.vcname}</td>
                            </tr>
                            <tr>
                                <td>Nama Panggilan</td>
                                <td>{data.vcnickname}</td>
                            </tr>
                            <tr>
                                <td>Nomor Telepon / HP</td>
                                <td>{data.vcphone}</td>
                            </tr>
                            <tr>
                                <td>Alamat</td>
                                <td>{data.vcaddress}</td>
                            </tr>
                            <tr>
                                <td>Foto</td>
                                <td><img src={vcimage} alt="default" width="20%" className={vcimage === '' || vcimage === null ? 'd-none' : ''}/></td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

Detail.propTypes = {}

export default Detail;